import {
    GET_ACCOUNT_ALERTS_PREFERENCES_PENDING, GET_ACCOUNT_ALERTS_PREFERENCES_FULFILLED, GET_ACCOUNT_ALERTS_PREFERENCES_FAILED
} from '../actions/actionTypes'
import { LoadingState } from '../helpers/enum'

const initialState = {
    loadingState: LoadingState.PENDING,
    items: []
}

export default function deliveryMethodReducer(state = initialState, action) {
    switch (action.type) {


        case GET_ACCOUNT_ALERTS_PREFERENCES_PENDING:
            return {
                ...state,
                loadingState: LoadingState.PENDING
            }
        case GET_ACCOUNT_ALERTS_PREFERENCES_FAILED:
            return {
                ...state,
                loadingState: LoadingState.FAILED
            }
        case GET_ACCOUNT_ALERTS_PREFERENCES_FULFILLED:
            return {
                ...state,
                loadingState: LoadingState.FULFILLED,
                items: action.data
            }
        default:
            return state;
    }

}